import React, { Component } from "react";
import Leaflet from "leaflet";
import "leaflet/dist/leaflet.css";
import Image from "react-bootstrap/Image";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";

delete Leaflet.Icon.Default.prototype._getIconUrl;

Leaflet.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export class Location extends Component {
    render() {
        let lat = 35.736554490710276;
        let lng = 51.319520429492606;
        const position = [lat, lng];
        const options = {
            doubleClickZoom: true,
            closePopupOnClick: false,
            dragging: false,
            touchZoom: true,
            scrollWheelZoom: false,

        };
        return (
            <section className="contact-crev">
                <div>
                    <div id="map" style={{height: 660}}>
                        <Map center={position} zoom={16} style={{ width: "100%", height: "100%" }} {...options}>
                            <TileLayer
                                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={position}><Popup>شرکت سرمایه گذاری عمران و توسعه پایدار ایرانیان</Popup></Marker>
                            <div className='share-location'>
                                <a href={'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng}
                                   title='نمایش در Google Maps'
                                   target='_blank'>
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/google-maps.png"}/>
                                </a>
                                <a href={'https://neshan.org/maps/@' + lat + ',' + lng + ',17.1z,0p/search/'}
                                   title='نمایش در نشان'
                                   target='_blank'>
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/neshan.png"}/>
                                </a>
                            </div>
                        </Map>
                    </div>
                </div>
            </section>
        );
    }
}
